import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const warnings = [
  "Enginev46DF",
  "ENG_OVHT46DF",
  "NAV_ERR21B3",
  "PWR_FLUX97AC",
  "WARN_ENGHEAT",
  "STABILIZER",
  "AIRLOCK_T7X",
  "BILGE_WARN",
  "EGCS_CODE75",
  "FUEL_LVLLOW",
  "STAB_SYS_FA",
  "SONAR_ECHO1",
  "WARN_NAV1X",
  "RDR_OFFLINE",
  "COMM_LOSSA7M",
  "STB_THRUSTER",
  "BATTERY_DR1",
  "SAT_LINKLOST",
  "PRT_THRUSTER",
  "WARN_HIGH_SOx",
];

function ShipDiagram() {
  const [activeWarning, setActiveWarning] = useState<string | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const randomWarning = warnings[Math.floor(Math.random() * warnings.length)];
      setActiveWarning(randomWarning);

      // Clear the warning after a few seconds
      setTimeout(() => setActiveWarning(null), 5000);
    }, 10000); // New warning every 5 sec

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-16 h-24 bg-black rounded-lg border border-blue-500 overflow-hidden">
      <img
        src="/images/ship-blueprint-front.png"
        alt="Ship Diagram"
        className="w-full h-full object-contain opacity-80"
      />

      {/* Example glowing status dot */}
      <div className="absolute top-8 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-green-400 rounded-full animate-pulse" />

      {/* Warning Text */}
      {activeWarning && (
        <motion.div
            initial={{ opacity: 0, x: 20 }}   // Start 20px to the right
            animate={{ opacity: 1, x: 0 }}    // Animate to center
            exit={{ opacity: 0, x: -20 }}      // Exit 20px to the left
            transition={{ duration: 1 }}
            className="absolute bottom-4 right-1/4 transform -translate-x-1/2 scale-75 text-red-400 text-[6px] font-bold drop-shadow-md"
          >
          {activeWarning}
        </motion.div>
      )}
    </div>
  );
}

export default ShipDiagram;
